export default __webpack_public_path__ + "assets/5604b78c20af6b3b6071bd4a4a53e0c3.svg";